<template>
	<div class="Set" :style="{ height: winH + 'px' ,'min-height':'670px'}">
		<van-nav-bar title="设置" fixed border>
			<template #left>
				<img src="../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
			</template>
		</van-nav-bar>
		<van-cell-group class="list" :style="(index>0)?'margin-top:15px !important':''" v-for="(litem,index) in listItem" :key="index">
			<van-cell is-link v-for="(item,ind) in litem" :key="'ld_'+ind" @click="directto(item)">
				<template slot="icon">
					<img :src="item.icon" />
				</template>
				<template slot="title">{{item.title}}</template>
				<template slot="default" v-if="item.code=='wxbind'">{{(wxUsers.length>0)?'已绑定':'未绑定'}}</template>
				<van-tag v-if="item.code=='wxbind' && wxUsers.length>0"  round type="danger">
					{{wxUsers.length}}
				</van-tag>
			</van-cell>
		</van-cell-group>
		<van-cell-group class="list" :style="'margin-top:15px !important'">
			<van-cell is-link @click="showAboutUs">
				<template slot="icon">
					<img :src="Conf.clientOrigin+'/upload/qrcode_shushizi.jpg'" class="icon" style="border-radius:10px;"/>
				</template>
				<template slot="title">
					关于熟柿子
				</template>
			</van-cell>
			<van-cell is-link @click="showShareSheet=true" :value="'邀请加入'">
				<template slot="icon">
					<img :src="Conf.clientOrigin+'/statics/logo_h5.png'" class="icon"/>
				</template>
				<template slot="title">
					分享
				</template>
			</van-cell>
			<van-cell is-link @click="checkUpdate" v-if="platforms=='app'">
				<template slot="icon">
					<img src="../../assets/img/icon/menu/ver_chk.png" class="icon" />
				</template>
				<template slot="title">
					检查新版本
					<div class="app_version_dot" v-if="new_app_flag">New</div>
				</template>
				<template slot="default">{{version}}</template>
			</van-cell>
			<van-cell is-link :url="Conf.clientOrigin+'/h5'" v-else>
				<template slot="icon">
					<img src="../../assets/img/icon/menu/download.png" class="icon" />
				</template>
				<template slot="title">
					下载APP
				</template>
				<template slot="default">{{version}}</template>
			</van-cell>
		</van-cell-group>

		<van-button type="danger" block @click="logOut()" class="van-button-exit">退出</van-button>
		

		<van-popup v-model="showBindWx" position="bottom" :style="{ 'max-height': '80%' }">
			<van-divider>
				绑定微信号（最多5个）
				<van-icon name="add" @click="addBindWx"  class="color_red" :style="{'margin-left':'10px'}" v-if="wxUsers.length<5"/>
			</van-divider>
			<van-cell-group>
				<van-cell v-for="(item,i) in wxUsers" :key="i" :title="item.nickname" :icon="item.headimgurl" :value="item.update_time">
					<template #right-icon>
						<van-button size="mini" type="danger" @click="unBindWx(item.id,i)" style="margin-left:5px">解除绑定</van-button>
					</template>
				</van-cell>
			</van-cell-group>
			<div style="padding:0 15px">
				<van-button type="default" block @click="showBindWx=false" style="margin:30px auto 20px auto">取消</van-button>
			</div>
		</van-popup>

		<van-popup v-model="showQRCodeUrl" position="bottom" :style="{ 'max-height': '80%' ,'text-align':'center','padding-bottom':'10px'}">
			<van-cell-group title="微信扫一扫" class="pay_type_group">
				<vue-qr :text="QRCodeUrl" :size="220"></vue-qr>
				<div style="padding:0 15px" v-if="QRCodeUrl!=Conf.clientOrigin">
					<van-button
					  class="btn"
					  v-clipboard:copy="QRCodeUrl"
					  v-clipboard:success="onCopy"
					  v-clipboard:error="onError"
					  style="width:100%;"
					>复制链接至微信打开</van-button>
				</div>
			</van-cell-group>
		</van-popup>

		<van-popup v-model="showAboutUsPopup" position="bottom" :style="{ 'height': '80%' ,'text-align':'left','padding-bottom':'10px'}">
			<div class="about_title">{{aboutUs.title||'关于熟柿子'}}</div>
			<div class="about_content" v-html="aboutUs.content||'暂无介绍内容！'"></div>
		</van-popup>

		<share :showShareSheet.sync="showShareSheet" :shareUrl="shareQRCodeUrl" :shareConfig="shareConfig" :botm="0" v-show="showShareSheet" v-if="initShareSheet"/>

  </div>
</template>
<script>
import { Divider} from "vant";
import vueQr from "vue-qr";
import Share from "@/components/Commom/Share";
import { newAppFlag, chkAppVersion } from "@/utils/upgrade.js";
import {compWxAuthUrl,chkWeiXin} from "@/utils/common.js";

export default {
	name: "My",
	components: {
		"van-divider":Divider,
		"vue-qr":vueQr,
		"share":Share
	},
	data() {
		return {
			title: "",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			userinfo: [],
			platforms: null,
			listItem: [
				[
					{
						icon: require("../../assets/img/icon/menu/passw.png"),
						title: "登录密码修改",
						to: "/Password"
					},
					{
						icon: require("../../assets/img/icon/menu/fsize.png"),
						title: "字体大小设置",
						to: "/Setfontsize"
					},
					{
						icon: require("../../assets/img/icon/menu/address.png"),
						title: "收货地址管理",
						to: "/Address"
					}
				  ],
				[
					{
						code:'wxbind',
						icon: require("../../assets/img/icon/wechat.png"),
						title: "微信账号"
					}
				  ]
			],
			winH: null,
			new_app_flag: false,
			wxUsers:[],
			showBindWx:false,
			wxConfigs:{},
			showQRCodeUrl:false,
			QRCodeUrl:'',
			showAboutUsPopup:false,
			aboutUs:{},
			
			showShareSheet:false,
			shareQRCodeUrl:this.Conf.clientOrigin,
			shareConfig:{
				title:top._SHARE_INFO.title,
				desc:top._SHARE_INFO.desc,
				link: this.Conf.clientOrigin, // 分享链接
				imgUrl: this.Conf.clientOrigin+'/statics/logo_h5.png'// 分享图标
			},
			initShareSheet:true

		};
	},
	created() {
		this.version = localStorage.getItem("version") || "0.0.0";
		this.platforms = this.Conf.platform;

		if(this.platforms != 'app'){
			this.getAppVersion();
		}
		this.new_app_flag = newAppFlag;
		this.getBindWxAccount();
		this.getStateWxConfigs();
		
	},
	methods: {
		goBack() {
			this.$router.push({
				name: "My",
				query: {
				}
			});
		},
		checkUpdate() {
			chkAppVersion(true);
		},
		getStateWxConfigs(){
			const confs = this.$store.state.common.wx_mp;
			if(confs){
				this.wxConfigs = confs
			}else{
				setTimeout(() => {
					this.getStateWxConfigs();
				},1000);
			}
		},
		getAppVersion(){
			var url = this.Conf.serverUrl + "Version/getVersionInfo";
			this.$axios
            .get(url, this.$qs.stringify({}))
            .then(res => {
				if (res.data.code == 200) {
					this.version = res.data.data.version;
				}
            })
            .catch(error => {
            });

		},
		directto(item){
			if(item.code == "wxbind"){
				this.showBindWx = true;
			}else{
				this.$router.push({path:item.to});
			}
		},
		getBindWxAccount(){
			var url = this.Conf.serverUrl + "User/wxAccounts" + "?num=" + Math.random();
			var data = {
				u_id: this.u_id,
				token: this.token
			};
			this.$axios
            .post(url, this.$qs.stringify(data))
            .then(response => {
				switch (response.data.code) {
					case 200:
						this.wxUsers = [];
						this.wxUsers = response.data.users;
						break;
					default:
						console.log(response.data)
						break;
				}
            })
            .catch(error => {
            });
		},
		addBindWx(){
			if(!this.wxConfigs.appid) return;
			let states = {
				'_t':'bind',
				'_uid':this.u_id
			};
			this.QRCodeUrl = compWxAuthUrl(this.wxConfigs, states);
			this.showQRCodeUrl = true;
		},
		unBindWx(a_id, i){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定解除绑定？",
			})
			.then(() => {
				var params = {
					u_id: this.u_id,
					token: this.token,
					a_id: a_id
				};
				let that = this;
				var url = this.Conf.serverUrl + "User/unBindAuth" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						that.getBindWxAccount();
					}
				})
				.catch(error => {});
				
			})
			.catch((error) => {});
			return false;
		},
		logOut() {
		  this.$dialog
			.confirm({
			  title: "温馨提示",
			  message: "是否退出",
			  className: "dialog-confirm",
			  showConfirmButton: true,
			  showCancelButton: true,
			  cancelButtonText: "取消",
			  confirmButtonText: "退出"
			})
			.then(() => {
				var url = this.Conf.serverUrl + "User/logOut" + "?num=" + Math.random();
				var data = {
					u_id: this.u_id,
					token: this.token
				};
				this.$axios
				.post(url, this.$qs.stringify(data))
				.then(response => {
					switch (response.data.code) {
						case 200:
							window.localStorage.clear();
							clearInterval(window.timer);
							this.$router.push({
								path: "/login"
							});
							break;
						case 40001:
							this.$toast.fail(response.data.msg);
							break;
					}
				})
				.catch(error => {
				});
			})
			.catch(() => {});
		},	
		showAboutUs(){
			this.showAboutUsPopup=true;
			if(!this.aboutUs.id){
				var url = this.Conf.serverUrl + "Common/docx" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify({code:'about_us'}))
				.then(response => {
					if(response.data.code == 40001){
						this.$toast.fail(response.data.msg);
						return false
					}
					if(response.data.data){
						this.aboutUs = response.data.data;
					}
				})
				.catch(error => {});
			}
		},
		getSiteConfig(){
			var params = {
				group: 'sys_site'
			};
			var url = this.Conf.serverUrl + "Dictionary/options" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				let datas = response.data.dicts;
				if(datas){
					for(var i in datas){
						this.siteConfig[datas[i].name] = datas[i].values
					}
				}
			})
			.catch(error => {});
		},
		// 复制成功
		onCopy(e) {
			this.$toast("复制成功！");
			this.showQRCodeUrl = false;
		},
		// 复制失败
		onError(e) {
			this.$toast("复制失败！");
		}
	}
};
</script>




// WEBPACK FOOTER //
// src/components/My/Set.vue